import app from './app';
import admin from './admin';

export default { app, admin };
